<!--
 * @FileDescription: 现金银行（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-21（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
    <div class="page-container">
        <div class="page-container-height">
           <div class="freight-top">
               <span>{{formData.startTime}}  至  {{formData.endTime}}</span>
               <span>账户：{{formData.name}}</span>
               <!--<span>此前余额：<span style="font-weight: 700">329.30</span></span>-->
           </div>
            <a-table :columns="columns"
                     :dataSource="dataSource"
                     :pagination="false"
                     class="table-freight"
                     :loading="loading"
                     bordered
                     :scroll="{y:'calc(100vh - 400px)' }"
                     rowKey="key">
                <template slot="footer">
                    <!--<a-table :columns="columns" class="table-footer-detail" :dataSource="footerDataSource" :pagination="false" :showHeader="false" rowKey="id"></a-table>-->
                    <div class="footer-total-amount">
                        <div class="footer-total-amount-left" style="width: 80px">
                            <span class="title">小计</span>
                        </div>
                        <div class="footer-total-amount-right" v-if="footerDataSource.length>0">
                            <span class="right-col">增加金额：{{ footerDataSource[0].addAmount }}</span>
                            <span class="right-col">减少金额：{{ footerDataSource[0].reduceAmount }}</span>
                        </div>
                    </div>
                </template>
            </a-table>
        </div>
        <freightModel ref="freightModel"></freightModel>
    </div>
</template>

<script>
    import {finacecondition} from "@/utils/api";
    import {mixins} from "@/mixins/mixins";
    import freightModel from './model/freightModel'
    export default {
        mixins:[mixins],
        data(){
            return{
                tabIndex:1,
                columns: [
                    {
                        title: '',
                        dataIndex: 'rowIndex',
                        key: 'rowIndex',
                        width: 80,
                        align: 'center',
                        customRender(t, r, index) {
                            return parseInt(index) + 1
                        }
                    },
                    {
                        title: '日期',
                        key: 'voucherDate',
                        dataIndex: 'voucherDate',
                    },
                    {
                        title: '单据编号',
                        key: 'voucherCode',
                        dataIndex: 'voucherCode',
                    },
                    {
                        title: '单据类型',
                        key: 'voucherType',
                        dataIndex: 'voucherType',
                        customRender: function (text, r) {
                          return text == 1 ? '采购入库单' : text == 2 ? '销售退货入库': text == 3 ? '其他入库':text == 4 ? '库存报溢':text == 5 ? '销售出库':text == 6 ? '采购退货出库':text == 7? '其他出库':text == 8? '库存报损':text == 9? '库存调拨':text == 10? '库存组装拆卸单':text == 11? '付款单': text == 12? '收款单':text == 13? '其他支出单': '其他收入单'
                        }
                    },
                    {
                        title: '摘要',
                        key: 'digest',
                        dataIndex: 'digest',
                    },
                    {
                        title: '往来单位',
                        key: 'contactCustomerName',
                        dataIndex: 'contactCustomerName',
                    },
                    {
                        title: '增加金额',
                        key: 'addAmount',
                        align:'right',
                        dataIndex: 'addAmount',
                    },
                    {
                        title: '减少金额',
                        key: 'reduceAmount',
                        align:'right',
                        dataIndex: 'reduceAmount',
                    },
                    {
                        title: '余额',
                        key: 'totalAmount',
                        align:'right',
                        dataIndex: 'totalAmount',
                    },
                    {
                        title: '备注',
                        key: 'remark',
                        dataIndex: 'remark',
                    },
                ],
                dataSource: [],
                footerDataSource: [],
                loading:true,
                formData:{}
            }
        },
        watch: {
        },
        beforeRouteUpdate(to,from,next){
            this.formData = JSON.parse(to.query.item)
            this.getList()
          next()
        },
        activated(){
            let item = decodeURIComponent(this.$route.query.item)
            this.formData = JSON.parse(item)
            this.getList()
        },
        mounted () {
            let item = decodeURIComponent(this.$route.query.item)
            this.formData = JSON.parse(item)
            this.getList()

        },
        created () {

        },
        components: {
            freightModel,

        },
        methods: {
            /** 表格增加合计行 */
            tableAddTotalRow (columns, dataSource) {
                this.footerDataSource = []
                let numKey = 'rowIndex'
                let totalRow = { [numKey]: '小计' }
                columns.forEach(column => {
                    let { key, dataIndex } = column
                    if (dataIndex == 'addAmount' || dataIndex == 'reduceAmount') {
                        let total = 0
                        dataSource.forEach(data => {
                            if(!this.isEmpty(data.voucherCode)){
                                if(this.isEmpty(data[dataIndex])){
                                  data[dataIndex] = 0
                                }
                                total = total +  parseFloat(data[dataIndex])
                            }
                        })
                        totalRow[dataIndex] = total
                    }
                })
                this.footerDataSource.push(totalRow)
              console.log(this.footerDataSource)
            },
            getList(){
                let data = {
                    startTime:this.formData.startTime,
                    endTime:this.formData.endTime,
                    companyStoreId : this.$store.state.shopId,
                    companyId : this.$store.state.companyId,
                    financeAccountId:this.formData.id,
                }
                data =   JSON.stringify(data)
                finacecondition(data,{ 'Content-Type':'application/json'}).then((res)=>{
                    if(res.success){
                        this.loading = false
                        this.dataSource = res.result
                      this.tableAddTotalRow(this.columns, this.dataSource)
                    }
                })
            },
            /**
             * @description: 此为方法注释（方法描述）
             * @param {参数类型} 参数名称
             * @return void
             */
            onAdd(index){
                if(index == 1){
                    this.$refs.freightModel.onOpen(3)
                }else if(index==2){
                    this.$refs.freightModel.onOpen(3)
                }else if(index == 3){

                }else if(index == 4){
                    this.$refs.freightModel.onOpen(5)
                }

            },

        },

    }
</script>
<style lang="scss">
    .table-freight{
        .ant-table{
            height: calc(100vh - 220px);
        }
        .ant-table-body{
            max-height: calc(100vh - 350px)!important;
        }
    }
    .table-footer-detail{
        .ant-table-tbody > tr > td:nth-child(1),
        .ant-table-tbody > tr > td:nth-child(7),
        .ant-table-tbody > tr > td:nth-child(8){
            color: #333333;
            font-weight: 700;
        }
        .ant-table-tbody > tr > td:nth-child(7),
        .ant-table-tbody > tr > td:nth-child(8){
            padding-right: 10px;
        }
        .ant-table{
            height: 60px;
        }
    }
</style>
<style scoped lang="scss">
.page-container-height{
    background-color: #fff;
    .freight-top{
        padding: 30px 0 17px 30px;
        color: #333;
        span{
            margin-right: 180px;
        }
    }

}
</style>


